import { createIcons } from 'lucide';
import {
  Activity,
  AlarmClock,
  AlertCircle,
  AlertTriangle,
  Archive,
  ArchiveRestore,
  ArchiveX,
  Aperture,
  ArrowDownUp,
  ArrowDownRight,
  ArrowLeft,
  ArrowRight,
  ArrowUpDown,
  ArrowUpRight,
  BadgeDollarSign,
  BadgeCheck,
  BadgePercent,
  BadgePlus,
  Bike,
  Ban,
  Banknote,
  Barcode,
  BarChart,
  BarChart2,
  BarChart3,
  Bell,
  BookCheck,
  BookOpen,
  Bookmark,
  Bot,
  Box,
  Boxes,
  Braces,
  Briefcase,
  Building,
  Building2,
  Calculator,
  Calendar,
  Car,
  CircleDashed,
  CircleDot,
  KanbanSquare,
  KeyRound,
  Signpost,
  CalendarCheck,
  CalendarOff,
  CalendarPlus,
  CalendarRange,
  CalendarSearch,
  CalendarX,
  CalendarClock,
  CalendarDays,
  Camera,
  ChartBar,
  ChartNoAxesCombined,
  ChartSpline,
  ChartColumnIncreasing,
  Check,
  CheckCheck,
  CheckCircle,
  CheckCircle2,
  CheckSquare,
  Circle,
  ChefHat,
  Church,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsDown,
  ChevronsUpDown,
  ClipboardCheck,
  ClipboardList,
  ClipboardPlus,
  Clock,
  Clock3,
  Coffee,
  Cloud,
  CloudDownload,
  CloudSun,
  Compass,
  Contact,
  Crosshair,
  CornerDownRight,
  Copy,
  CreditCard,
  Database,
  DatabaseZap,
  Divide,
  DollarSign,
  Donut,
  Download,
  DownloadCloud,
  Edit,
  Edit2,
  Edit3,
  Equal,
  Eraser,
  ExternalLink,
  Eye,
  EyeOff,
  File,
  FileCheck,
  FileCheck2,
  FileCode2,
  FilePlus,
  FilePlus2,
  FileSearch,
  FileUp,
  FileDown,
  FileSpreadsheet,
  FileText,
  Fingerprint,
  Filter,
  Flame,
  Flag,
  FlagTriangleRight,
  Folder,
  FolderLock,
  FolderPlus,
  FolderOpen,
  Gauge,
  GitBranch,
  GitCompare,
  Globe,
  GripVertical,
  Footprints,
  Hammer,
  HardHat,
  Handshake,
  Hash,
  HelpCircle,
  History,
  Hexagon,
  Home,
  Hospital,
  Hotel,
  Hourglass,
  Image,
  ImageUp,
  ImageOff,
  Inbox,
  Info,
  Layers,
  Layers3,
  Landmark,
  LayoutDashboard,
  LayoutGrid,
  LineChart,
  LifeBuoy,
  Link,
  Link2,
  List,
  ListChecks,
  ListTree,
  ListFilter,
  ListOrdered,
  ListPlus,
  Loader,
  Loader2,
  LoaderCircle,
  Lock,
  Unlock,
  Mail,
  MailCheck,
  LogIn,
  LogOut,
  LocateFixed,
  Map,
  MapPin,
  MapPinOff,
  MapPinPlus,
  MapPinned,
  Maximize2,
  Medal,
  Megaphone,
  Minus,
  MoreVertical,
  Milk,
  Milestone,
  MessageCircle,
  MessageSquare,
  MessageSquareText,
  MessagesSquare,
  Move,
  Navigation,
  Newspaper,
  PanelLeftClose,
  PanelLeftOpen,
  PanelRightOpen,
  Palette,
  Pencil,
  PenLine,
  Percent,
  PieChart,
  Pin,
  PlayCircle,
  PlugZap,
  Plus,
  PlusCircle,
  Power,
  Package,
  Paperclip,
  PartyPopper,
  PackageOpen,
  PackageSearch,
  PackageX,
  Play,
  Printer,
  Receipt,
  ReceiptText,
  Radio,
  RefreshCcw,
  RefreshCw,
  Repeat2,
  Orbit,
  Rocket,
  RotateCcw,
  Route,
  Ruler,
  ScanSearch,
  ScanFace,
  ScanLine,
  Satellite,
  Save,
  Scissors,
  Search,
  SearchCheck,
  SearchX,
  Send,
  Settings,
  Settings2,
  Shield,
  ShieldAlert,
  ShieldCheck,
  ShoppingBag,
  Sliders,
  SlidersHorizontal,
  Smile,
  Smartphone,
  Snowflake,
  Sparkles,
  Stamp,
  Star,
  StarHalf,
  Store,
  School,
  GraduationCap,
  Dumbbell,
  Sheet,
  Table,
  TableProperties,
  Tag,
  Tags,
  Target,
  Ticket,
  TicketCheck,
  Timer,
  ToggleLeft,
  Trash,
  Trash2,
  Type,
  TrendingDown,
  TrendingUp,
  Trophy,
  Truck,
  Train,
  Droplets,
  Undo2,
  Upload,
  UploadCloud,
  Utensils,
  Variable,
  Video,
  Webhook,
  User,
  UserCheck,
  UserCog,
  UserPlus,
  UserRoundPlus,
  UserX,
  Users,
  Users2,
  UsersRound,
  Wallet,
  Warehouse,
  Wrench,
  X,
  XCircle,
  Zap,
} from 'lucide';

const icons = {
  Activity,
  AlarmClock,
  AlertCircle,
  AlertTriangle,
  TriangleAlert: AlertTriangle,
  Archive,
  ArchiveRestore,
  ArchiveX,
  Aperture,
  ArrowDownUp,
  ArrowDownRight,
  ArrowLeft,
  ArrowRight,
  ArrowUpDown,
  ArrowUpRight,
  BadgeDollarSign,
  BadgeCheck,
  BadgePercent,
  BadgePlus,
  Bike,
  Ban,
  Banknote,
  Barcode,
  BarChart,
  BarChart2,
  BarChart3,
  Bell,
  BookCheck,
  BookOpen,
  Bookmark,
  Bot,
  Box,
  Boxes,
  Braces,
  Briefcase,
  Building,
  Building2,
  Calculator,
  Calendar,
  Car,
  CircleDashed,
  CircleDot,
  KanbanSquare,
  KeyRound,
  Signpost,
  CalendarCheck,
  CalendarOff,
  CalendarPlus,
  CalendarRange,
  CalendarSearch,
  CalendarX,
  CalendarClock,
  CalendarDays,
  Camera,
  ChartBar,
  ChartNoAxesCombined,
  ChartSpline,
  ChartColumnIncreasing,
  Check,
  CheckCheck,
  CheckCircle,
  CheckCircle2,
  CheckSquare,
  Circle,
  ChefHat,
  Church,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronsDown,
  ChevronsUpDown,
  ClipboardCheck,
  ClipboardList,
  ClipboardPlus,
  Clock,
  Clock3,
  Coffee,
  Cloud,
  CloudDownload,
  CloudSun,
  Compass,
  Contact,
  Crosshair,
  CornerDownRight,
  Copy,
  CreditCard,
  Database,
  DatabaseZap,
  Divide,
  DollarSign,
  Donut,
  Download,
  DownloadCloud,
  Edit,
  Edit2,
  Edit3,
  Equal,
  Eraser,
  ExternalLink,
  Eye,
  EyeOff,
  File,
  FileCheck,
  FileCheck2,
  FileCode2,
  FilePlus,
  FilePlus2,
  FileSearch,
  FileUp,
  FileDown,
  FileSpreadsheet,
  FileText,
  Fingerprint,
  Filter,
  Flame,
  Flag,
  FlagTriangleRight,
  Folder,
  FolderLock,
  FolderPlus,
  FolderOpen,
  Gauge,
  GitBranch,
  GitCompare,
  Globe,
  GripVertical,
  Footprints,
  Hammer,
  HardHat,
  Handshake,
  Hash,
  HelpCircle,
  History,
  Hexagon,
  Home,
  Hospital,
  Hotel,
  Hourglass,
  Image,
  ImageUp,
  ImageOff,
  Inbox,
  Info,
  Layers,
  Layers3,
  Landmark,
  LayoutDashboard,
  LayoutGrid,
  LineChart,
  LifeBuoy,
  Link,
  Link2,
  List,
  ListChecks,
  ListTree,
  ListFilter,
  ListOrdered,
  ListPlus,
  ListSearch: ListFilter, // compat: legacy data-lucide="list-search"
  Loader,
  Loader2,
  LoaderCircle,
  Lock,
  Unlock,
  Mail,
  MailCheck,
  LogIn,
  LogOut,
  LocateFixed,
  Map,
  MapPin,
  MapPinOff,
  MapPinPlus,
  MapPinned,
  Maximize2,
  Medal,
  Megaphone,
  Minus,
  MoreVertical,
  Milk,
  Milestone,
  MessageCircle,
  MessageSquare,
  MessageSquareText,
  MessagesSquare,
  Move,
  Navigation,
  Newspaper,
  PanelLeftClose,
  PanelLeftOpen,
  PanelRightOpen,
  Palette,
  Pencil,
  PenLine,
  Percent,
  PieChart,
  Pin,
  PlayCircle,
  PlugZap,
  Plus,
  PlusCircle,
  Power,
  Package,
  Paperclip,
  PartyPopper,
  PackageOpen,
  PackageSearch,
  PackageX,
  Play,
  Printer,
  Receipt,
  ReceiptText,
  Radio,
  RefreshCcw,
  RefreshCw,
  Repeat2,
  Orbit,
  Rocket,
  RotateCcw,
  Route,
  Ruler,
  ScanSearch,
  ScanFace,
  ScanLine,
  Satellite,
  Save,
  Scissors,
  Search,
  SearchCheck,
  SearchX,
  Send,
  Settings,
  Settings2,
  Shield,
  ShieldAlert,
  ShieldCheck,
  ShoppingBag,
  Sliders,
  SlidersHorizontal,
  Smile,
  Smartphone,
  Snowflake,
  Sparkles,
  Stamp,
  Star,
  StarHalf,
  Store,
  School,
  GraduationCap,
  Dumbbell,
  Sheet,
  Table,
  TableProperties,
  Tag,
  Tags,
  Target,
  Ticket,
  TicketCheck,
  Timer,
  ToggleLeft,
  Trash,
  Trash2,
  Type,
  TrendingDown,
  TrendingUp,
  Trophy,
  Truck,
  Train,
  Droplets,
  Undo2,
  Upload,
  UploadCloud,
  Utensils,
  Variable,
  Video,
  Webhook,
  User,
  UserCheck,
  UserCog,
  UserPlus,
  UserRoundPlus,
  UserX,
  Users,
  Users2,
  UsersCog: UserCog, // compat: legacy data-lucide="users-cog"
  UsersRound,
  Wallet,
  Warehouse,
  Wrench,
  X,
  XCircle,
  Zap,
};

const lucideApi = {
  icons,
  // Pre-bundle only the icons we use and expose the same API the CDN build provides.
  createIcons(options = {}) {
    return createIcons({ icons, ...options });
  },
};

if (typeof window !== 'undefined') {
  window.lucide = lucideApi;
}

export default lucideApi;
export const lucideIcons = icons;
export const createLucideIcons = lucideApi.createIcons;
